import { ReportTableComponent } from "../reporttable.component";
import { Component, OnInit } from "@angular/core";
import { AlertService } from "../../util/alert/alert.service";
import { SharedService } from "../../home/shared.service";
import { Report } from "../report.model";
import { ReportService } from "../report.service";

@Component({
	selector: "app-checklistreport",
	templateUrl: "./checklistreport.component.html"
})
export class ChecklistReportComponent extends ReportTableComponent implements OnInit {
	public report: Report;
	public excelData: any[];
	public columns: Array<any> = [
		{
			title: "Checklist",
			name: "Checklist",
			filtering: { filterString: "" }
		},
		{
			title: "Tags",
			name: "Tags",
			filtering: { filterString: "" }
		}
	];
	private serverResultData: Array<any> = [];

	config: any = {
		paging: true,
		sorting: { columns: this.columns },
		filtering: { filterString: "" },
		className: ["table-striped", "table-bordered" ]
	};

	constructor(
		private alertService: AlertService,
		private sharedService: SharedService,
		private reportService: ReportService
	) {
		super();
		this.report = this.reportService.getSelectedReport();
	}

	ngOnInit() {
		this.loadChecklistWithTags(this.report.reportData);
	}

	loadChecklistWithTags(data: any) {
		this.excelData = [];
		for (let i = 0; i < data.length; i++) {
			this.data.push({
				Checklist: data[i].Description,
				Tags: data[i].Tags == null ? "" : data[i].Tags
			});

			// this.excelData.push({
			//   Checklist: data[i].Description,
			//   Tags: data[i].Tags == null ? "" : data[i].Tags
			// });
		}
		//  this.report.reportDataList = this.excelData;
		this.report.columns = this.columns;
		this.config.report = this.report;
		this.serverResultData = data;
		this.pageCount = Math.ceil(
			this.serverResultData.length / this.itemsPerPage
		);
		this.onChangeTable(this.config);
	}
}
